<template>
    <div class="leftO">
        <breadcrumb :routerList="[{title:'个人中心'}]"/>

        <!--		修改经销商信息页面-->
        <div class="left" v-if="this.usertype=='1' || this.oldAgentCode != ''">
            <div class="containImgBox" style="text-align: center;margin-bottom: 10px;">
                <div class="headBox" v-if="this.oldAgentCode == ''">
                    <div v-for="(item,index) in fileList" :key="index" v-if="showTX">
                        <img :src="item.saveurl">
                    </div>
                    <img src="../../assets/images/defaultHead.png" v-if="!showTX">
                </div>
                <div class="btngroup" style="display: flex;align-items: center;justify-content: center"
                     v-if="this.oldAgentCode == '' ">
                    <bruploadTX
                            :refid=_user.usercode
                            :reftype=touXiang
                            uploadflag
                            delflag
                    >
                    </bruploadTX>
					<el-button style="margin-left:0.2rem" @click="xiugai" class="h-btn h-bBtn">修改密码
					</el-button>
                    <el-button style="margin-left:0.2rem" @click="tuichu" class="h-btn h-bBtn h-bgblueQ2">退出登录
                    </el-button>

                </div>
            </div>

            <!--            <div class="titles">账户信息</div>-->
            <!--            <div class="zhanghu">-->
            <!--                <div class="h-formLine" style="margin-top:0.38rem">-->
            <!--                    <el-form :model="formLabelAlign1.bscUserInfo" label-position="right" ref="formLabelAlign1a"-->
            <!--                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
            <!--                        <el-form-item label="用户名" class="h-elformWrap-2" prop="username">-->
            <!--                            <el-input v-model="formLabelAlign1.bscUserInfo.username" placeholder="请填写"></el-input>-->
            <!--                        </el-form-item>-->
            <!--                    </el-form>-->
            <!--                </div>-->
            <!--            </div>-->

            <!-- <div class="titles" style="margin-top:20px">客户资质信息</div> -->
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                <h1>经销商类型</h1>
            </div>
            <div style="margin-top: 5px;">
                <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">* 如果您是直单用户，请勾选下方按钮，如果不是请不要勾选！</div>
                <el-switch
						style="font-size: 0.16rem;"
                        @change="chooseZhiDan"
                        v-model="isZhiDan"
                        class="zhidangc"
                        active-text="是否是直单用户"
                        inactive-text="">
                </el-switch>
                <el-switch
                        style="margin-left: 50px;"
                        v-if="this.isZhiDan == true"
                        class="zhidangc"
                        @change="chooseGoverment"
                        v-model="isGoverment"
                        active-text="是否是政府企业/军工企业"
                        inactive-text="">
                </el-switch>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                <h1>客户资质信息</h1>
            </div>
            <div class="signsign">
                <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                             ref="formLabelAlign1a"
                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                      @change="beUpdateBas+=1" disabled
                                      placeholder="请填写完整的公司全称"></el-input>
                        </el-form-item>
                        <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                                      placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="客户" class="h-elformWrap-2" prop="scale">
                            <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
                                       @change="beUpdateBas+=1"
                                       placeholder="请选择">
                                <el-option label="小规模经营者" value="0"></el-option>
                                <el-option label="一般纳税人" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                      @change="beUpdateBas+=1"
                                      placeholder="请填写详细的公司地址"></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="邮政编码" class="h-elformWrap-2" prop="postalCode">-->
                        <!--                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.postalCode" maxlength="6"-->
                        <!--                                      show-word-limit @change="beUpdateBas+=1"-->
                        <!--                                      placeholder="请填写"></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="legal">
                          <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.personnelNum" @change="beUpdateBas+=1"
                                    placeholder="请填写"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="总经理联系方式" class="h-elformWrap-2" prop="legal">
                          <el-input  v-model="formLabelAlign1.bscUserInfoAgentBasic.legalPhone"  @change="beUpdateBas+=1"
                                    placeholder="请填写"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="经营其他品牌" class="h-elformWrap-2" prop="legal" >
                          <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.brand"  @change="beUpdateBas+=1"
                                    placeholder="请填写"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.email" @change="beUpdateBas+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="公司性质" class="h-elformWrap-2" prop="companytype">
                            <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                                       @change="beUpdateBas+=1"
                                       placeholder="请选择">
                                <el-option label="体外诊断类" value="体外诊断类"></el-option>
                                <el-option label="实验室仪器类" value="实验室仪器类"></el-option>
                                <el-option label="实验室EPC类" value="实验室EPC类"></el-option>
                                <el-option label="医疗影像设备类" value="医疗影像设备类"></el-option>
                                <el-option label="试剂耗材" value="试剂耗材"></el-option>
                                <el-option label="医疗科研软件服务类" value="医疗科研软件服务类"></el-option>
                                <el-option label="社区卫生服务类" value="社区卫生服务类"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.name1" @change="beUpdateBas+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                                      @change="beUpdateBas+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="所在国家" class="h-elformWrap-2" prop="country"
                                      v-if="agentType == 3">
                            <brselectlazy category="YLCountry_agent" :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                          v-model="formLabelAlign1.bscUserInfoAgentBasic.country" :clearable="true"
                                          @change="beUpdateBas+=1"
                                          style="width:2.18rem" disabled/>
                        </el-form-item>
                        <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                      v-if="agentType == 1 || agentType == 2">
                            <brselectlazy category="YLRegion" :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                          v-model="formLabelAlign1.bscUserInfoAgentBasic.region" :clearable="true"
                                          @change="beUpdateBas+=1"
                                          :disabled="isShowRegion"
                            />
                        </el-form-item>
                        <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity"
                                      v-if="agentType == 1 || agentType == 2">
                            <el-select
                                    filterable
                                    @change="beUpdateBas+=1"
                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                                    placeholder="请选择">
                                <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
<!--                        <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity"-->
<!--                                      v-if="this.formLabelAlign1.bscUserInfoAgentBasic.agentType != '3'">-->
<!--                            <el-select-->
<!--                                    filterable-->
<!--                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"-->
<!--                                    placeholder="请选择">-->
<!--                                <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"-->
<!--                                      v-if="this.agentType==1||this.agentType==2">-->
<!--                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode" maxlength="18"-->
<!--                                      show-word-limit @change="beUpdateBas+=1"-->
<!--                                      placeholder="请填写"></el-input>-->
<!--                        </el-form-item>-->

                    </el-form>
                </div>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                <h1>开票信息</h1>
                <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;font-weight: normal;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
            </div>
            <!-- <div class="titles" style="margin-top:0">开票信息
                 <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;font-weight: normal;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
             </div> -->
            <div class="signsign">
                <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                             ref="formLabelAlign1b"
                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="客户名称" class="h-elformWrap-2" prop=customerName1>
                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                      @change="beUpdateBank+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="开票电话" class="h-elformWrap-2" prop=phoneNumber>
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"
                                      @change="beUpdateBank+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom">
                            <el-input clearable v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                                      @change="beUpdateBank+=1">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"
                                      v-if="agentType == 1 || agentType == 2">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"
                                      @change="beUpdateBank+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right" ref="formLabelAlign1c"
                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="银行编号" class="h-elformWrap-2" prop="bankBranchCode">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                                      @change="getBackName()"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankName">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
                                      placeholder="请填写" @change="beUpdateBank+=1"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账户号" class="h-elformWrap-2" prop="accountHolderName">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                      @change="beUpdateBank+=1"
                                      placeholder="请填写"></el-input>
                        </el-form-item>
                        <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                            <brselectlazy category="YLCountry_agent"
                                          :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry" :clearable="true"
                                          @change="beUpdateBank+=1"
                            />
                        </el-form-item>
                    </el-form>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1d"
                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1">
                            <el-select placeholder="请选择" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1"
                                       @change="beUpdateBank+=1">
                                <el-option label="增值税发票" value="01"></el-option>
                                <el-option label="普通发票" value="02"></el-option>
                            </el-select>
                        </el-form-item>
                      <el-form-item label="电票邮箱" class="h-elformWrap-2" prop="inEmail">
                        <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.inEmail" @change="beUpdateBank+=1"
                                  placeholder="请填写"></el-input>
                      </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="signsign">
                <!-- <div class="titles" style="margin-top:0">邮寄发票信息</div> -->
                <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                    <h1>邮寄发票信息</h1>
                </div>
                <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                             ref="formLabelAlign1e"
                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver"
                                      placeholder="请填写" @change="beUpdateBank+=1"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone">
                            <el-input v-model="formLabelAlign1.bscUserInfoAgentCompany.receiverphone"
                                      placeholder="请填写" @change="beUpdateBank+=1"></el-input>
                        </el-form-item>
                        <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress">
                            <el-input clearable v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress" @change="beUpdateBank+=1">
                                <i
                                        class="el-icon-edit el-input__icon"
                                        slot="suffix"
                                        @click="handleIconClick" @change="beUpdateBank+=1">
                                </i>
                            </el-input>

                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!-- <div class="titles" style="margin-top:0;margin-bottom: 30px;">上传附件</div> -->
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                <h1>上传附件</h1>
            </div>
            <div class="h-formLine weekplandetail">
                <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                         ref="formLabelAlign1f"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload">
                        <brupload

                                :refid="refid"
                                reftype="代理商注册-企业营业执照"
                                uploadflag
                                delflag
                                :showtime="false"

                        >
                        </brupload>
                    </el-form-item>
                    <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload">
                        <brupload
                                :refid="refid"
                                reftype="代理商注册-银行开户证明"
                                uploadflag
                                delflag
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>
                    <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate">
                      <el-date-picker
                          style="width: 180px"
                          :refid="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                          @change="beUpdateSall+1"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload">
                        <brupload
                                :refid="refid"
                                reftype="代理商注册-法人身份证"
                                uploadflag
                                delflag
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>
                    <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload">
                        <brupload
                                :refid="refid"
                                reftype="代理商注册-一般纳税人提供相关资质证明"
                                uploadflag
                                delflag
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>
                    <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload">
                        <brupload
                                :refid=formLabelAlign1.bscUserInfoAgentBasic.usercode
                                reftype="代理商修改名称-见证性资料"
                                uploadflag
                                delflag
                                :showtime="false"
                                @filecallback="fileBack1">
                        </brupload>
                    </el-form-item>
                    <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload">
                        <brupload
                                :refid=formLabelAlign1.bscUserInfoAgentBasic.usercode
                                reftype="代理商修改发票-见证性资料"
                                uploadflag
                                delflag
                                :showtime="false"
                                @filecallback="fileBack2">
                        </brupload>
                    </el-form-item>
                    <el-form-item label="备案表" class="h-elformWrap-2" prop="upload" v-show="have2">
                        <brupload

                                :refid="refid"
                                reftype="代理商注册-二类经营许可证"
                                uploadflag
                                delflag
                                :showtime="false"
                        >
                        </brupload>

                    </el-form-item>
                    <el-form-item label="" class="HAVES-l h-elformWrap-1" v-show="have2">
                            <el-switch
                                    style="margin-left: 1rem;"
                                    v-model="have6858"
                                    active-text=""
                                    inactive-text="是否包含6858">
                            </el-switch>
                            <el-switch
                                    style="margin-left: 1rem;"
                                    v-model="have6840"
                                    active-text=""
                                    inactive-text="是否包含6840">
                            </el-switch>
                    </el-form-item>

                  <el-form-item label="" class="HAVES-l h-elformWrap-1" v-show="have2">
                      <el-switch
                              style="margin-left: 1rem;"
                              v-model="havepolicy2017"
                              @change="choose2017"
                              active-text=""
                              inactive-text="是否包含2017版分类目录">
                      </el-switch>
                      <el-switch
                          style="margin-left: 0.4rem;"
                          v-model="have1101"
                          active-text=""
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          inactive-text="是否包含11-01">
                      </el-switch>
                      <el-switch
                          style="margin-left: 0.4rem;"
                          v-model="have2214"
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          active-text=""
                          inactive-text="是否包含22-14">
                      </el-switch>
                    <el-switch
                            style="margin-left: 0.4rem;"
                            v-model="have2215"
                            v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                            active-text=""
                            inactive-text="是否包含22-15">
                    </el-switch>
                    <el-switch
                            style="margin-left: 0.4rem;"
                            v-model="have2216"
                            v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                            active-text=""
                            inactive-text="是否包含22-16">
                    </el-switch>
                  </el-form-item>

					<div style="margin-left: 2.3rem;margin-bottom: 0.38rem;">
						<el-switch
						        v-model="have3"
						        active-text=""
						        inactive-text="是否有许可证">
						</el-switch>
					</div>
                    <!-- <el-form-item label="" class="h-elformWrap-1"
                                  style="margin-left: 1.7rem;">
                        <el-switch
                                v-model="have3"
                                active-text=""
                                inactive-text="是否有许可证">
                        </el-switch>
                    </el-form-item> -->
                    <el-form-item label="许可证" class="h-elformWrap-2" prop="upload" v-show="have3">
                        <brupload
                                :refid="refid"
                                reftype="代理商注册-三类经营许可证"
                                uploadflag
                                delflag
                                :showtime="false"
                        >
                        </brupload>

                    </el-form-item>
                    <el-form-item label="" class="h-elformWrap-2" v-show="have3">
                        <el-switch
                                style="margin-left: 2.3rem;width: 2rem;"
                                v-model="have6854"
                                active-text=""
                                inactive-text="是否包含6854">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate" v-show="have3">
                      <el-date-picker
                          style="width: 180px"
                          :refid="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                          type="date"
                          @change="beUpdateSall+1"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>



        </div>
		<div style="display: flex;justify-content: center;align-items: center;"  v-if="this.usertype=='1' || this.oldAgentCode != ''">
		            <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
		<!--            <el-button class="h-btn h-bBtn h-bggreen" @click="zancun"-->
		<!--                       v-if="taskid == undefined ||taskid == ''">暂存-->
		<!--            </el-button>-->
		            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="update('formLabelAlign1')"
		                       v-if="taskid == undefined ||taskid == ''">提交修改
		            </el-button>
		            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="reupdate()"
		                       v-if="taskid != undefined&&taskid != '' ">重新提交
		            </el-button>
		        </div>
        <!--		修改供应商信息页面-->
        <div class="left" v-if="this.usertype=='2' && this.oldAgentCode == ''">
            <div class="containImgBox" style="text-align: center;margin-bottom: 10px;">
                <div class="headBox">
                    <div v-for="(item,index) in fileList" :key="index" v-if="showTX">
                        <img :src="item.saveurl">
                    </div>
                    <img src="../../assets/images/defaultHead.png" v-if="!showTX">
                </div>
                <div class="btngroup" style="display: flex;align-items: center;justify-content: center">
                    <bruploadTX
                            :refid=_user.usercode
                            :reftype=touXiang
                            uploadflag
                            delflag
                    >
                    </bruploadTX>
					<el-button style="margin-left:0.2rem" @click="xiugai" class="h-btn h-bBtn">修改密码
					</el-button>
                    <el-button style="margin-left:0.2rem" @click="tuichu" class="h-btn h-bBtn h-bgblueQ2">退出登录
                    </el-button>

                </div>
            </div>
            <div class="detail">
                <div class="h-pieceTitle2" style="margin-left:10px">
					<h1>基本信息</h1>
				</div>
                <div class="zhongbiao">
                    <div class="zhongbiaoWrapper clear">
                        <div class="left4 leftw">
                            <span class="spanN">用户角色</span>
                            <span class="spanT">
								<span v-for="(o,i) in this._user.roles" :key="i">{{o.name}}&nbsp;</span>
							</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">用户姓名</span>
                            <span class="spanT">{{this._user.username}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">用户账号</span>
                            <span class="spanT">{{this._user.usercode}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">手机号</span>
                            <span class="spanT">{{this._user.phone}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">邮箱</span>
                            <span class="spanT">{{this._user.email}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">组织部门</span>
                            <span class="spanT">{{this._user.deptname}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--		修改内部人员信息页面-->
        <!--		todo-->
        <div class="left" v-if="this.usertype=='0' && this.oldAgentCode == '' ">
            <div class="containImgBox" style="text-align: center;margin-bottom: 10px;">
                <div class="headBox">
                    <div v-for="(item,index) in fileList" :key="index" v-if="showTX">
                        <img :src="item.saveurl">
                    </div>
                    <img src="../../assets/images/defaultHead.png" v-if="!showTX">
                </div>
                <div class="btngroup" style="display: flex;align-items: center;justify-content: center"
                     v-if="this.oldAgentCode == '' ">
                    <bruploadTX
                            :refid=_user.usercode
                            :reftype=touXiang
                            uploadflag
                            delflag
                    >
                    </bruploadTX>
					<el-button style="margin-left:0.2rem" @click="xiugai" class="h-btn h-bBtn">修改密码
					</el-button>
                    <el-button style="margin-left:0.2rem" @click="tuichu" class="h-btn h-bBtn h-bgblueQ2">退出登录
                    </el-button>

                </div>
            </div>
            <div class="detail">
                <div class="h-pieceTitle2" style="margin-left:10px">
					<h1>基本信息</h1>
				</div>
                <div class="zhongbiao">
                    <div class="zhongbiaoWrapper clear">
                        <div class="left4 leftw" v-if="this.oldAgentCode == '' ">
                            <span class="spanN">用户角色</span>
                            <span class="spanT">
								<span v-for="(o,i) in this._user.roles" :key="i">{{o.name}}&nbsp;</span>
							</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">用户姓名</span>
                            <span class="spanT">{{this._user.username}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">用户账号</span>
                            <span class="spanT">{{this._user.usercode}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">手机号</span>
                            <span class="spanT">{{this._user.phone}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">邮箱</span>
                            <span class="spanT">{{this._user.email}}</span>
                        </div>
                        <div class="left4 leftw">
                            <span class="spanN">组织部门</span>
                            <span class="spanT">{{this._user.deptname}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

	<areaSelect :visible.sync="showflag" @choseObj="choseObj" v-if="showflag" @change="beUpdateBank+=1"
	            v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"/>
    </div>
</template>
<script>
    import userinService from "../../api/personal/userinService"
    import uploaddown from '../../utils/updownfile'
    import ss from "../../api/SystemService"

    export default {
        data() {
            var validateemail = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请输入必填项！"));
                } else if (value !== '') {
                    // if (/^\w+([-+.,]\w+)*@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/.test(value)) {
                    callback();
                    // } else {
                    //     callback(new Error("邮箱格式不正确！"));
                    // }
                }
            };
            var validateTaxCode = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请输入必填项！"));
                } else if (value !== '') {
                    if (/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)) {
                        callback();
                    } else {
                        callback(new Error("格式不正确！"));
                    }
                }
            };
            var validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请输入必填项！"));
                } else if (value !== '') {
                    if (/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error("手机号格式不正确！"));
                    }
                }
            };
            return {
                MdmBankconfigInput: {
                    bankBranchCode: '',
                },
                isZhiDan: false,
                isGoverment: false,
                companyData: '',
                refid: '',
                isShowRegion: true,
                havepolicy2017:false,
                have6858: false,
                have6840: false,
                have6854: false,
                have1101: false,
                have2214: false,
                have2215: false,
                have2216: false,
                have: false,
                have2: true,
                have3: false,
                oldAgentCode: '',
                showTX: false,
                fileList: [],
                addli: [],
                touXiang: "用户头像",
                taskid: '',
                file1: '',
                file2: '',
                duname: '',
                fptype: '',
                ind: null,
                index: ['a', 'b', 'c', 'd', 'e', 'f'],
                beUpdateInfo: 0,
                beUpdateBas: 0,
                beUpdateCom: 0,
                beUpdateSall: 0,
                beUpdateBank: 0,
                flag: 0,
                agentType: '1',
                showflag: false,
                isShowMassage: true,
                data: '',
                usertype: '',
                usercode: '',
                formLabelAlign1: {
                    bscUserInfoAgentBasic: {
                        usercode: null,
                        customerNumber: null,
                        accountGroup: null,// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
                        customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
                        customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
                        searchTerm: null,// 搜索项 ,  ,   ,   ,
                        postalCode: null,// 邮政编码 ,  ,   ,   ,
                        country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
                        region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
                        cityStreetRoom: '',// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
                        streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
                        phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
                        language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
                        faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
                        contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
                        companyCodeGeneral: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
                        companyCode: null,// 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
                        taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
                        name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
                        phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
                        companyAddress: null,// 公司地址名 ,  ,   ,   ,
                        contactCity: null,// 联系人城市 ,  ,   ,   ,
                        appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
                        partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用，0：删除标志
                        scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
                        http: null,//公司网址
                        companytype: null, //公司性质
                        founded: null,//成立时间
                        regmoney: null,//注册资本
                        legal: null,//法人姓名
                        introduce: null,//公司简介
                        business: null,//主营
                        achievement: null,//业绩
                        resource: null,//资源
                        email: null,//公司邮箱
                        upload5: null,
                        upload6: null,
                        personnelNum:null,//销售人员数量
                        brand:null,//经营其他品牌
                        legalPhone:null,//总经理联系方式
                    },
                    bscUserInfoAgentBank: {
                        usercode: null,//公司编码
                        accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
                        bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
                        bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用，0：删除标志
                        vatCode: null,//VAT税号
                        bankName: null//银行名称
                    },
                    bscUserInfoAgentSell: {
                        usercode: null,//公司编码
                        distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
                        division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
                        salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
                        salesRegion: null,// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
                        customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
                        currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
                        customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
                        shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
                        accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
                        custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
                        podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        orderPossibility: null,// 订单可能性 ,  ,   ,   ,
                        intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
                        intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
                        fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
                        orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
                        customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
                        customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
                        customerGroup3: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
                        customerGroup3NotMain: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
                        rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        permit: null,//资质标识 1二级 2三级
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用，0：删除标志
                        customerAssignGroup: '0210', //客户分配账户组: 10内销-集团内 20内销-集团外
                        auditMind1: null, //审核意见
                        auditMind2: null, //审核意见
                        xkzEffectiveDate:'',//许可证有效到期日
                        yyzzEffectiveDate:'',//营业执照有效日期
                        inEmail:''
                    },
                    bscUserInfoAgentCompany: {
                        usercode: null,//公司编码
                        companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
                        hq: null,// 总部 ,  ,   ,   ,
                        reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
                        sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
                        paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用，0：删除标志
                        mailreceiver: null,//邮寄接收人
                        receiverphone: null,//接收人电话
                        mailaddress: null,//邮寄地址
                    },
                    bscUserInfo: {
                        usercode: null,//员工编码/公司编码
                        password: '',//密码
                        usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
                        username: '',//公司名称/员工姓名username
                        email: null,//邮箱
                        phone: null,//联系人电话
                        deptcode: null,//所属部门编码deptcode  公司用户为空
                        userdept: null,//用户详细部门userdept  公司用户为空
                        deptname: null,//部门名称deptname  公司用户为空
                        firstline: null,//一线经理firstline  公司用户为空
                        secondline: null,//二线经理secondline  公司用户为空
                        status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
                        organization: null,//公司地址/住址机构
                        cdate: null,//创建时间
                        ldate: null,//更新时间
                        logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
                        lastlogintime: null,//最后登录时间: 记录最后登录时间
                        accountdate: null,//账户有效期
                        area: null,//负责区域
                        lucode: null,//更新人编码
                        countrytype: null,//1- 国内  /  2- 国外   账户
                        fileId: null,
                        aaa: null,
                        taskid: null,
                        isActive: null,
                    }
                },
                rules: {
                    username: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    country:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    email: [
                        {required: true, validator: validateemail, trigger: 'blur'},
                    ],
                    contactCity: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    region:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    scale:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    taxCode:
                        [
                            // {required: true, validator: validateTaxCode, trigger: 'blur'},
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    contactMobilePhone:
                        [
                            {required: true, validator: validatePhone, trigger: 'blur'},
                        ],
                    cityStreetRoom:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    streetRoom:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    phoneNumber:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    name1:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    phoneNumber1:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    companyCodeGeneral:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    accountHolderName:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    bankCountry:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
					bankName:
					    [
					        {required: true, message: '请填写必填项', trigger: 'blur'},
					    ],
					customerGroup1:
					    [
					        {required: true, message: '请填写必填项', trigger: 'blur'},
					    ],
                    bankBranchCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    companyCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    reconcileAccount:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    distributionChannel:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    salesGroup:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    salesRegion:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    currencyCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    accountDistributeGroup:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    upload5:
                        [
                            {required: true, message: '请上传资料', trigger: 'blur'},
                        ],
                    upload6:
                        [
                            {required: true, message: '请上传资料', trigger: 'blur'},
                        ],
                },
            }
        },
        created() {
            if (this.$route.query.usercode != undefined) {
              console.log(11111);
                // this.refid = this.$route.query.usercode;
                console.log(this.$route.query.usercode, 'usercode')
                this.oldAgentCode = this.$route.query.usercode;
                this.queryAgent();
            } else {
              console.log(22222);
                this.usertype = this.$store.getters.user.usertype;
                console.log(this.$store.getters.user.usercode);
                console.log("******************************");
                this.usercode = this.$store.getters.user.usercode;

                // this.refid = this.$store.getters.user.usercode;
                this.taskid = this.$route.query.taskid;
                console.log(this.usertype, this.usercode, '登录人，经销商/供应商');
                // 查询登录人具体信息
                this.queryData();
                this.loadFilelist();
            }
            this.findAddress();
        },
        methods: {
            findAddress() {
                ss.SignService.selectAddress().then(response => {
                    this.addli = response;
                })
            },
            fileBack1(v) {
                this.file1 = v.length;
            },
            fileBack2(v) {
                this.file2 = v.length;
            },
			xiugai(){
				this.$router.push('/resetPass')
			},
            chooseZhiDan() {
                this.beUpdateBas += 1;
                if (this.isZhiDan) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
                } else {
                    this.isGoverment = false;
                    this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
                    this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
                }
            },
            chooseGoverment() {
                if (this.isGoverment) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "政府/军工企业";
                } else {
                    this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
                }

            },
            getBackName() {
                this.beUpdateBank += 1;
                this.MdmBankconfigInput.bankBranchCode = this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode;
                console.log(this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode, 'yinhang')
                ss.SignService.getBackName(this.MdmBankconfigInput).then(response => {
                    console.log(response, '银行名称对象')
                    if (response.obj.bankTable.value.bankItem[0].bankName != undefined){
                        this.formLabelAlign1.bscUserInfoAgentBank.bankName = response.obj.bankTable.value.bankItem[0].bankName;
                    }
                })
            },
            queryAgent() {
                ss.SignService.queryAgent(this.oldAgentCode).then(res => {
                    console.log(res, '经销商信息')
                    this.data = res.obj;
                    console.log(this.data.fileidInfo, '附件显示');
                    if (this.data.fileidInfo && this.data.fileidInfo != '') {
                        this.refid = this.data.fileidInfo;
                    } else {
                        this.refid = this.$util.getUuid();
                    }

                    if (!res.obj.regionBas || res.obj.regionBas == undefined || res.obj.regionBas == '') {
                        this.isShowRegion = false;
                    }

                    ss.SignService.checkCompany(res.obj.customername1Bas).then(response => {
                        if (response.f) {
                            this.companyData = response.obj.data;
                            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
                            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
                            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
                            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
                            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
                            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
                            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
                            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
                            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
                            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
                        } else {
                            callback(new Error('该公司已被注册，请直接登录！'))
                        }
                    })
                    this.checkDetail();
                    this.MdmBankconfigInput.bankBranchCode = res.obj.bankbranchcodeBank;
                    ss.SignService.getBackName(this.MdmBankconfigInput).then(response => {
                        console.log(response, '银行名称对象')
                        if (response.obj.bankTable.value.bankItem[0].bankName != undefined){
                            this.formLabelAlign1.bscUserInfoAgentBank.bankName = response.obj.bankTable.value.bankItem[0].bankName;
                        }

                    })
                })
            },
            //经销商查看功能对应展示数据功能
            checkDetail() {
                this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
                this.formLabelAlign1.bscUserInfo.isActive = this.data.isActiveInfo
                if(this.data.usercodeBas) {
                     this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
                }else {
                    this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeInfo
                }


                this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
                this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
                this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

                this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
                this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
                if(this.data.customername1Bas) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                    this.duname = this.data.customername1Bas
                }else {
                    this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.usernameInfo
                    this.duname = this.data.usernameInfo
                }
                if (this.data.scaleBas !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
                this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
                this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
                this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
                this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
                this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
                //this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
                this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone = this.data.legalPhoneBas
                this.formLabelAlign1.bscUserInfoAgentBasic.brand = this.data.brandBas
                this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum = this.data.personnelNumBas

                if (this.data.iszhidanBas == 1){
                    this.isZhiDan = true;
                }
                this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
                this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank

                this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
                this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
                if (this.data.customergroup1Sell !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
                this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
                this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
                this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
                this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
                this.fptype = this.data.customergroup1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customergroup3NotMainSell
                this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
                this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
                this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
                this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority  = this.data.isExpandAuthorityBas;
                if (this.data.agentTypeBas == '3' || this.data.isExpandAuthorityBas == 1) {
                  this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell;
                  this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell;
                }

                this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
                this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
                this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
                this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = this.data.isFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = this.data.statusFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = this.data.instidFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = this.data.signingFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
                this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
                this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
                this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
                this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = this.data.associatedCompanyNameBas
                this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = this.data.associatedCompanyCodeBas
                this.formLabelAlign1.bscUserInfoAgentSell.invInformation = this.data.invInformation
                this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
              if (this.data.have6840Sell == 1) {
                    this.have6840 = true;
                }
                if (this.data.have6854Sell == 1) {
                    this.have6854 = true;
                }
                if (this.data.have6858Sell == 1) {
                    this.have6858 = true;
                }
                if (this.data.permitSell == 3 || this.data.permitSell == 5) {
                    this.have3 = true;
                }
                if (this.data.have1101Sell == 1) {
                  this.have1101 = true;
                }
                if (this.data.have2214Sell == 1) {
                  this.have2214 = true;
                }
                if (this.data.have2215Sell == 1) {
                  this.have2215 = true;
                }
                if (this.data.have2216Sell == 1) {
                  this.have2216 = true;
                }
                if (this.data.havepolicy2017Sell == 1) {
                    this.havepolicy2017 = true;
                }

            },
            loadFilelist() {
                uploaddown.listTX().then(rd => {
                    this.fileList = rd.obj;
                    if (rd.obj.length > 0) {
                        this.fileList.forEach(elements => {
                            ss.UserCare.imgDown(elements.id).then(data => {
                                var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
                                    byte), ''));
                                if (imgbase != 'data:image/png;base64') {
                                    elements.saveurl = imgbase;
                                }
                            });
                        });
                        this.showTX = true;
                    } else {
                        this.showTX = false;
                        console.log(this.showTX, "2323232");
                    }
                })
            },
            reupdate() {
                userinService.reUpdate(this.taskid);
                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                })
            },
            goBack() {
                var defaultpage = this.$store.getters.user.defaultpage;
                this.$router.push({path: defaultpage});
            },
            zancun() {
                userinService.zancun(this.formLabelAlign1).then(res => {

                })
            },
            update(formName) {
                var flag = 0;
                for (var i = 0; i < this.index.length; i++) {
                    this.ind = this.index[i];
                    var form = formName + this.ind;
                    this.$refs[form].validate((valid) => {
                      console.log(form,valid);
                        if (valid) {

                        } else {
                            flag = flag + 1;
                            return false;
                        }
                    });
                }
                if (flag !== 0) {
                    this.$message({
                        type: "error",
                        message: "请先填写必要信息后再提交！"
                    });
                    return false;
                }
                if (this.duname != this.formLabelAlign1.bscUserInfoAgentBasic.customerName1) {
                    if (!this.file1 || this.file1 == '') {
                        this.$msg.msge("公司名称修改后请上传--名称修改见证性资料！");
                        return false;
                    }
                }
                if (this.fptype != this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1) {
                    if (!this.file2 || this.file2 == '') {
                        this.$msg.msge("发票类型修改后请上传--发票类型见证性资料！");
                        return false;
                    }
                }
                if (!this.havepolicy2017) {
                    this.$msg.msge("请勾选是否包含2017版分类目录！");
                    return false;
                }
                this.formLabelAlign1.beUpdateBank = this.beUpdateBank;
                this.formLabelAlign1.beUpdateInfo = this.beUpdateInfo;
                this.formLabelAlign1.beUpdateBas = this.beUpdateBas;
                this.formLabelAlign1.beUpdateCom = this.beUpdateCom;
                this.formLabelAlign1.beUpdateSall = this.beUpdateSall;
                this.formLabelAlign1.bscUserInfo.fileId = this.refid;
                if (this.have2 === true && this.have3 === false) {
                    this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
                } else if (this.have2 === false && this.have3 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
                } else if (this.have2 === true && this.have3 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
                } else if (this.have2 === false && this.have3 === false) {
                    this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
                }
                if (this.have6858 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
                }
                if (this.have6840 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
                }
                if (this.have6854 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
                }
                if (this.have1101 === true) {
                  this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
                } else {
                  this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
                }
                if (this.have2214 === true) {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
                } else {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
                }
                if (this.have2215 === true) {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
                } else {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
                }
                if (this.have2216 === true) {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
                } else {
                  this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
                }
                if (this.havepolicy2017 === true) {
                    this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
                }
                this.formLabelAlign1.bscUserInfo.username = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
                this.formLabelAlign1.bscUserInfo.email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
                this.formLabelAlign1.bscUserInfo.area = this.formLabelAlign1.bscUserInfoAgentBasic.region;
                this.formLabelAlign1.bscUserInfo.fileId = this.refid;
                this.formLabelAlign1.bscUserInfo.isUpdate = 1;

                userinService.update(this.formLabelAlign1).then(response => {
                    if (response.f) {
                        if ("提交修改信息成功，无需审批！" == response.msg) {
                            this.$msg.msgs(response.msg);
                        } else {
                            this.$alert(response.msg, '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.$message({
                                        type: 'info',
                                        message: '已退出系统'
                                    });
                                }
                            });
                            // this.$message({
                            //     type: "success",
                            //     message: response.msg
                            // });
                            // var defaultpage = this.$store.getters.user.defaultpage;
                            // this.$router.push({path: defaultpage});
                            this.$router.push("/login");
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }
                })
            },
            choseObj(obj) {
                console.log(obj);
                this.showflag = false;
                if (obj.zhenobj && obj.zhenobj.name) {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
                }
            },
            choose2017(){
                if (this.havepolicy2017) {
                    this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
                    console.log("包含2017版分类目录")
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
                    console.log("不包含2017版分类目录")
                }
            },
            handleIconClick() {
                this.showflag = true;
            },
            //经销商查看功能对应展示数据功能
            // checkDetail() {
            //     this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
            //     this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
            //     this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
            //     this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
            //     this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell
            //
            //     this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
            //     this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
            //     this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
            //     if (this.data.scaleBas !== undefined) {
            //         this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
            //     }
            //     this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
            //     this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
            //     this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
            //     this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
            //     this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
            //     if (this.data.scaleBas !== undefined) {
            //         this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
            //     }
            //     this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
            //     this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
            //     this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
            //     this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
            //     this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
            //     this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 = this.data.auditmind2Sell
            //     this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
            //     this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
            //     this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
            //     this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
            //     this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
            //     this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
            //     this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
            //     this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
            //     this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
            //     this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
            //     this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
            //     this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
            //     this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
            //     if (this.data.have6840Sell == 1) {
            //         this.have6840 = true;
            //     }
            //     if (this.data.have6854Sell == 1) {
            //         this.have6854 = true;
            //     }
            //     if (this.data.have6858Sell == 1) {
            //         this.have6858 = true;
            //     }
            // },
            // 查询登录人具体信息
            queryData() {
                userinService.queryData(this.usercode).then(response => {
                    this.data = response.obj;
                    console.log(this.data, '登录人具体信息');
                    console.log(this.data.fileidInfo, '附件显示');
                    if (this.data.fileidInfo && this.data.fileidInfo != '') {
                        this.refid = this.data.fileidInfo;
                    } else {
                        this.refid = this.$util.getUuid();
                    }
                    // 如果是海外经销商，对应某些字段不显示
                    if (this.data.customerassigngroupSell == '0260') {
                        this.isShowMassage = false;
                        this.agentType = '3';
                    } else if (this.data.customerassigngroupSell == '0280') {
                        this.agentType = '1';
                    } else if (this.data.customerassigngroupSell == '0210') {
                        this.agentType = '2';
                    }
                    this.checkDetail();
                    console.log(this.duname,"经销商名称");
                    console.log(this.fptype,"发票类型");
                })
            },
            tuichu() {
                this.$msg.confirm("确认退出？", () => {
                    this.$store.commit("LOGOUT")
                })
            },
        }
    }
</script>
<style scoped>
    .zhanghu {
        margin-bottom: 40px;
    }

    .left {
        width: 96%;
        /* overflow: auto; */
        background-color: rgb(255, 255, 255);
        margin: 30px 30px 60px 30px;
        padding-bottom: 65px;
        border: 1px solid #E2E2E2;
        padding: 30px 40px 60px;
        display: flex;
        flex-direction: column;
    }

    .avatar {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 0;
    }

    .avatar-wrapper {
        width: 220px;
        height: 220px;
        border: 10px solid #F6F7FA;
        border-radius: 50%;
    }

    .avatar-wrapper > img {
        width: 200px;
        height: 200px;
        border: 10px solid #EDF0F5;
        border-radius: 50%;
    }

    .xunjia {
        color: #0e75e9;
        display: inline-block;
        padding-left: 10px;
        border-left: 5px solid #0e75e9;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 30px;
    }

    .zhongbiao {
        margin-left: 20px;
        overflow: hidden;
    }

    .zhongbiaoWrapper {
        margin-right: -20px;
    }

    .left4 {
        width: 50%;
        float: left;
        height: 27px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
    }
	.leftw {
		font-size: 0.16rem;
	}

    .spanN {
        width: 85px;
        margin-right: 25px;
        text-align: right;
        color: #656565;
    }

    .spanT {
        width: 65%;
        border-bottom: 1px solid #E2E2E2;
        padding-bottom: 0.02rem;
        color: #8A8A8A;
        text-indent: 1em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .btngroup {
        margin-top: 0.2rem;
    }

    .headBox {
        width: 1.8rem;
        height: 1.8rem;
        border-radius: 50%;
        margin: 0 auto;
        overflow: hidden;
    }

    .headBox img {
        width: 100%;
        height: 100%;
    }
    .weekplandetail .h-formbLine .el-form-item.HAVES-2 .el-form-item__label {
        width: 10%;
    }

    .weekplandetail .h-formbLine .el-form-item.HAVES-2 .el-form-item__content {
        width: 90%;
    }
    .weekplandetail .h-formbLine .el-form-item.HAVES-l .el-form-item__label {
        width: 10%;
    }

    .weekplandetail .h-formbLine .el-form-item.HAVES-l .el-form-item__content {
        width: 90%;
    }
</style>
<style>


    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 27.5%;
    }

    .signsign .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .signsign .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .signsign .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .weekplandetail .h-formbLine .el-form-item__label {
        width: 44%;
    }

    .weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 26%;
    }

    .weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 74%;
    }

    .weekplandetail .h-formbLine .el-form-item__content {
        width: 56%;
    }

    .weekplandetail .h-formbLine .el-form-item.HAVES-l .el-form-item__label {
        width: 10%;
    }

    .weekplandetail .h-formbLine .el-form-item.HAVES-l .el-form-item__content {
        width: 90%;
    }

    .weekplandetail .el-upload-list__item .el-icon-close-tip {
        right: 40px;
    }

    .zhidangc {
        margin-bottom: 0.2rem;
    }
</style>
